module.exports = __webpack_public_path__ + "img/santiago.98b2f255.jpg";